import React, { useState, useRef } from 'react'
import { Input } from '../forms'
import { Button } from '../button/v2'
import SchedulingCoupon from '../schedulingCoupon'
import Alert from 'src/components/alert'
import Info from 'static/icons/info-circle_gray.svg'
import MODAL from 'src/utils/modals'
import { focus } from 'src/utils'
import * as S from './styles'
import { actionTypes, useServiceScheduleContext } from '../../context/serviceScheduleContext'

const CouponField = ({ coupon, addCoupon, removeCoupon, context, bestDiscount }) => {
  const { dispatch } = useServiceScheduleContext()
  const [couponValue, setCouponValue] = useState(undefined)
  const [appliedAttempt, setAppliedAttempt] = useState(undefined)
  const [error, setError] = useState(undefined)
  const renderErrorIcon = !error ? undefined : 'error-exclamation'
  const inputRef = useRef(null)
  const handleInputFocus = () => {
    focus(inputRef, 'smooth', true)
  }
  const bestDiscountIsCampaign = bestDiscount?.promotion === 'campaign'
  const warningAlert = couponValue === appliedAttempt && bestDiscountIsCampaign && couponValue && !error

  const infoModalBody =
    <S.ModalBody>
      <strong>Os cupons são acumulativos?</strong>
      <p>Não. Nossos cupons de desconto para serviços não são cumulativos com outros cupons, promoções ou descontos de compra programada.</p>
      <br />
      <strong>Quais os tipos de cupom?​ </strong>
      <p>Os cupons podem oferecer desconto em porcentagem ou valor fixo sobre o total da compra.​</p>
      <br />
      <strong>Posso utilizar mais de uma vez o cupom?​ </strong>
      <p>Cada cupom tem uma condição específica:​</p>
      <li>Alguns cupons podem ser usados <strong>apenas uma vez por CPF.</strong>​</li>
      <li>Outros podem ter <strong>uso ilimitado</strong> dentro do período da campanha.​</li>
      <p className='specificConditions'>- Verifique as condições específicas de cada cupom.​</p>
      <br />
      <strong>O cupom é válido para qualquer serviço?</strong>
      <p>Não. Cada cupom possui regras específicas sobre quais serviços são elegíveis.​</p>
      <p className='specificConditions'>- Verifique as condições específicas de cada cupom.​</p>
    </S.ModalBody>
  return (
    <S.FieldWrapper>
      <S.Title>
        <h2>Cupom de desconto</h2>
        <Info onClick={() => dispatch({
          type: actionTypes.UPDATE_STATE,
          payload: {
            modal: MODAL.INFO_COUPON({ body: infoModalBody })
          }
        })}
        />
      </S.Title>
      <S.InputWrapper ref={inputRef}>
        <Input
          rightIcon={renderErrorIcon}
          errorMessage={error}
          value={couponValue}
          onChange={(e) => setCouponValue(e.target.value)}
          onFocus={handleInputFocus}
          labelOnFocus
          label='Insira seu cupom aqui'
          placeholder='Insira seu cupom aqui'
          type='text'
          name='coupon'
          margin='0'
        />
        <Button
          customWidth='120px'
          onClick={async () => {
            setAppliedAttempt(couponValue)
            await addCoupon({
              context,
              coupon: couponValue,
              callback: (message) => setError(message)
            })
          }}
          disabled={context.loading || !!coupon || !couponValue}
          customHeight='40px'
          outline
        >
            Aplicar
        </Button>
      </S.InputWrapper>
      {!!coupon && (
        <>
          <SchedulingCoupon coupon={coupon} removeCoupon={removeCoupon} />
          <Alert show type='info' margin='16px 0 0 0'>O cupom foi reservado. Finalize o agendamento o quanto antes para não correr o risco de esgotar a quantidade disponível.</Alert>
        </>
      )}

      <Alert
        show={warningAlert}
        margin='0px'
        type='warning'
        textContent='Este cupom não pode ser usado junto a outro cupom ou campanha promocional.'
      />

    </S.FieldWrapper>
  )
}

export default CouponField
